module.exports = __webpack_public_path__ + "static/img/avatar-03.3ef7fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-03.jpg
// module id = 6nH6
// module chunks = 22